import { DateRange, SavedDateRange } from '../../components/DateRangeFilter';
import { modifiedDate } from '../time';

export const convertToDateRangeDates = (savedDates: SavedDateRange): DateRange => {
  return {
    start: savedDates.start ? new Date(savedDates.start) : null,
    end: savedDates.end ? new Date(savedDates.end) : null,
  };
};

export const convertToSavedDates = (dateRange: DateRange): SavedDateRange => {
  return {
    start: dateRange.start ? modifiedDate(dateRange.start) : null,
    end: dateRange.end ? modifiedDate(dateRange.end) : null,
  };
};
